var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplorerMobileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 682,
    viewBox: "0 0 375 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1002_7638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.231 26.9072C413.231 140.074 109.458 470.481 -43.0898 251.438C-141.815 109.679 -373 121.132 -373 7.96472C-373 -105.202 -118.619 -178 70.6073 -178C259.833 -178 413.231 -86.2599 413.231 26.9072Z",
    fill: "#5620C7",
    fillOpacity: 0.74
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1002_7638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.0963 -120.093C57.0963 -6.92566 494.394 36.1718 305.168 36.1718C115.942 36.1718 -558 130.49 -558 17.3227C-558 -95.8444 -474.754 -325 -285.528 -325C-96.3016 -325 57.0963 -233.26 57.0963 -120.093Z",
    fill: "#310E95",
    fillOpacity: 0.73
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1002_7638",
    x: -729.892,
    y: -534.892,
    width: 1500.02,
    height: 1216.59,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 178.446,
    result: "effect1_foregroundBlur_1002_7638"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1002_7638",
    x: -914.892,
    y: -681.892,
    width: 1624.45,
    height: 1111.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 178.446,
    result: "effect1_foregroundBlur_1002_7638"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorerMobileBg);
export default __webpack_public_path__ + "static/media/explorer-mobile-bg.d16dcaeec23483ab509ec99d92c9e41f.svg";
export { ForwardRef as ReactComponent };